import React from 'react';
import { IIconProps } from '../interfaces';

const AleaPlusIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '15',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 51">
      <path
        id="Line 20"
        d="M7.5 1L7.5 14"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        id="Line 21"
        d="M1 7.5L14 7.5"
        stroke={color}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default AleaPlusIcon;
